import { GoFocusApp } from './core/GoFocusApp.js';

if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

if (typeof window !== 'undefined') {
  window.GoFocusApp = GoFocusApp;
}

if (
  typeof window !== 'undefined' &&
  typeof document !== 'undefined' &&
  !window.__GOFOCUS_DISABLE_AUTO_INIT__ &&
  document.getElementById('app')
) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new GoFocusApp();
    });
  } else {
    new GoFocusApp();
  }
}
